module.exports = __webpack_public_path__ + "static/media/account3x.7bb3082a.png";